import cx from 'classnames';
import React, { HTMLProps } from 'react';
import { styles } from '.';

export type InputElementContainerProps = {
  error: boolean;
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'date';
  fluid?: boolean;
  multiline?: boolean;
  elementContainerRef?: React.RefObject<HTMLDivElement>;
} & Omit<HTMLProps<HTMLDivElement>, 'size'>;

export const InputElementContainer = ({
  size,
  fluid,
  multiline,
  elementContainerRef,
  error,
  disabled,
  children,
  ...props
}: InputElementContainerProps) => {
  return (
    <div
      ref={elementContainerRef}
      className={cx(
        styles.inputContainer,
        styles[size || 'medium'],
        multiline && !disabled && styles.hasMultiline,
        fluid && styles.fluid,
        error && styles.error
      )}
      {...props}
    >
      {children}
    </div>
  );
};
